import { render, staticRenderFns } from "./shuibiaoyanbiaoshenqing.vue?vue&type=template&id=67f36010&scoped=true&"
import script from "./shuibiaoyanbiaoshenqing.vue?vue&type=script&lang=js&"
export * from "./shuibiaoyanbiaoshenqing.vue?vue&type=script&lang=js&"
import style0 from "./shuibiaoyanbiaoshenqing.vue?vue&type=style&index=0&id=67f36010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f36010",
  null
  
)

export default component.exports